module.exports = __webpack_public_path__ + "img/男鞋2.32fdb6af.png";